import React from 'react';

import styles from './MerchantProfil.module.css';

const Description = ({ description }) => {
    return (
        <div className={styles.categories}>
            <h1 className={styles.title}>Description</h1>
            <p
                className={styles.description}>
                {description}
            </p>
        </div>
    );
};

export default Description;